/**
 * Gets a unique ID based on the currentAccountIds session item
 * Returns a unix timestamp rounded to the nearest minute as a fallback
 */
export default function getSessionId() {
  const currentAccountIds = sessionStorage.getItem('currentAccountIds');
  let isCurrentAccountIdsValid = !!currentAccountIds;
  let sessionId = currentAccountIds;

  if (currentAccountIds) {
    const currentAccountIdsArray = currentAccountIds.split('-');
    isCurrentAccountIdsValid =
      currentAccountIdsArray.length === 3 &&
      currentAccountIdsArray.every(i => i.length > 0);
  }

  if (!isCurrentAccountIdsValid) {
    // CP-7169 NA: Generate a timestamp rounded to the nearest minute to allow for one minute of caching when missing ID
    const millisecondsInAMinute = 1000 * 60;
    sessionId =
      Math.round(new Date().getTime() / millisecondsInAMinute) *
      millisecondsInAMinute;
  }

  return sessionId;
}
